import React from 'react';
import { useTranslation } from 'react-i18next';
import './AudioSampleRateInput.scss';
import { Option } from '../../../common/interfaces';
import { Dropdown } from '../../FormComponents/Dropdown/Dropdown';
import { AudioSampleRateEnum } from '../../../types/enums/AudioSampleRateEnum';
import useProject from '../../../hooks/useProject';
import Help from '../../Help/Help';

const AudioSampleRateInput = () => {
  const { t } = useTranslation();
  const { updateEncoder, updateStream, project } = useProject();
  const options: Option[] = [];

  for (const key in AudioSampleRateEnum) {
    if (isNaN(Number(key))) {
      options.push({
        text: `${key.split(/(?=[A-Z])/).join(' ')}`,
        value: `${AudioSampleRateEnum[key as keyof typeof AudioSampleRateEnum]}`,
      });
    }
  }

  const onChange = (option: Option) => {
    if (project.stream.sourceLanguageIsoCode === project.encoder.languageIsoCode) {
      updateStream({
        transcoderAudioSampleRate: parseInt(option.value),
      });
    } else {
      updateEncoder(project.encoder, {
        transcoderAudioSampleRate: parseInt(option.value),
      });
    }
  };

  return (
    <div className="audio-sample-rate-input">
      <div className="input-title">
        {t('producer.inputs.audio-sample-rate.title')}
        <Help
          title="Audio Sample Rate"
          text="<b>CD Quality:</b> Standard 44.1 kHz sample rate, suitable for most music and voice streams.<br/><br/><b>Professional:</b> Higher 48 kHz sample rate, providing improved audio fidelity for professional streaming.<br/><br/><b>High Definition:</b> 96 kHz sample rate, ideal for studio-quality audio and high-fidelity applications."
        />
      </div>
      <Dropdown
        value={project.encoder.transcoderAudioSampleRate.toString()}
        options={options}
        onChange={onChange}
        placeholderKey="producer.inputs.audio-sample-rate.placeholder"
        readonly={false}
      />
      <div className="input-component-footer">{t('producer.inputs.audio-sample-rate.footer')}</div>
    </div>
  );
};

export default React.memo(AudioSampleRateInput);
